module.exports = __webpack_public_path__ + "static/media/home_evaporation_graph.b8f1f200.gif";